/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

type KeyEventTypes = 'keydown' | 'keyup' | 'keypress';

@Directive({ selector: '[keyEvent]' })
export class KeyEventDirective implements OnInit, OnDestroy {

  @Input() keys: string[] = [];
  @Input() events: KeyEventTypes[] = ['keydown'];

  @Output() keyEvent = new EventEmitter<KeyboardEvent>();

  ngOnInit() {
    this.events.forEach(eventType => {
      window.addEventListener(eventType, this.handleEvent.bind(this));
    });
  }

  ngOnDestroy() {
    this.events.forEach(eventType => {
      window.removeEventListener(eventType, this.handleEvent.bind(this));
    });
  }

  private handleEvent(event: KeyboardEvent) {
    if (this.keys.includes(event.key)) {
      this.keyEvent.emit(event);
    }
  }
}
